import { Link } from 'react-router-dom';

export function LegalPage({
  title,
  updated,
  children
}: {
  title: string;
  updated: string;
  children: React.ReactNode;
}) {
  return (
    <article className="page-anim" style={{ maxWidth: 760, margin: '0 auto' }}>
      <Link to="/" className="crumb">← Home</Link>
      <h1 className="page-title">{title}</h1>
      <p className="mono muted" style={{ fontSize: 12.5, marginBottom: 28 }}>
        Last updated: {updated}
      </p>
      <div className="legal-body">{children}</div>
    </article>
  );
}

export function LegalSection({ heading, children }: { heading: string; children: React.ReactNode }) {
  return (
    <section style={{ marginBottom: 30 }}>
      <h2 style={{ fontFamily: 'var(--font-serif)', fontWeight: 600, fontSize: 21, margin: '0 0 10px' }}>
        {heading}
      </h2>
      <div style={{ color: 'var(--ink2)', lineHeight: 1.7, fontSize: 15.5 }}>{children}</div>
    </section>
  );
}
